import {inlineError} from '@s-ui/decorators'
import {Service} from '@s-ui/domain'

/**
 * @implements Service
 */
export class GetSubscriptionModelsVehiclesService extends Service {
  constructor({httpVehiclesRepository}) {
    super()
    this._httpRepository = httpVehiclesRepository
  }

  @inlineError
  async execute() {
    const [getSubscriptionModelsVehiclesError, getSubscriptionModelsVehiclesResponse] =
      await this._httpRepository.getSubscriptionModels()
    if (getSubscriptionModelsVehiclesError) return Promise.reject(getSubscriptionModelsVehiclesError)

    return getSubscriptionModelsVehiclesResponse
  }
}
